var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container-box" }, [
      _c(
        "div",
        {
          staticClass: "content-row content-align-center",
          staticStyle: { background: "#fff" }
        },
        [
          _c("div", { staticClass: "hasrisk-icon" }),
          _vm._v(" "),
          _c("div", { staticStyle: { color: "#0170a6" } }, [
            _vm._v("\n        " + _vm._s(_vm.$t("detection")) + "\n        "),
            _c(
              "span",
              {
                staticClass: "font-24",
                staticStyle: { margin: "0 .5rem", color: "#fe5b3f" }
              },
              [_vm._v(_vm._s(_vm.tips.riskCount))]
            ),
            _vm._v("\n        " + _vm._s(_vm.$t("item")) + "\n      ")
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { overflow: "hidden" } }, [
        _c("div", { staticStyle: { margin: "0 -.1rem" } }, [
          _c(
            "div",
            {
              staticClass: "content-row",
              staticStyle: {
                background: "#e2edff",
                "flex-wrap": "wrap",
                padding: ".1rem  .1rem 0 0"
              }
            },
            [
              _c("Symp_itemIpad", {
                attrs: {
                  riskLevelList: _vm.riskLevelList,
                  tips: _vm.tips,
                  classleve: _vm.classleve,
                  mClass: _vm.mClass,
                  nClass: false,
                  isShow: true,
                  hClass: _vm.hClass
                },
                on: { setModalInfo: _vm.setModalInfo }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content-row content-align-center",
          staticStyle: { background: "#fff" }
        },
        [
          _c("div", { staticClass: "norisk-icon" }),
          _vm._v(" "),
          _c("div", { staticStyle: { color: "#0170a6" } }, [
            _vm._v(_vm._s(_vm.$t("otherDetecation")))
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { overflow: "hidden" } }, [
        _c("div", { staticStyle: { margin: "0 -.1rem" } }, [
          _c(
            "div",
            {
              staticClass: "content-row",
              staticStyle: {
                background: "#e2edff",
                "flex-wrap": "wrap",
                padding: ".1rem  .1rem 0 0"
              }
            },
            [
              _c("Symp_itemIpad", {
                attrs: {
                  riskLevelList: _vm.mildRisks,
                  tips: _vm.mtips,
                  classleve: _vm.classleve,
                  mClass: true,
                  nClass: false,
                  isShow: _vm.isShow,
                  hClass: false
                },
                on: { setModalInfo: _vm.setModalInfo }
              }),
              _vm._v(" "),
              _c("Symp_itemIpad", {
                attrs: {
                  riskLevelList: _vm.normalRisks,
                  tips: _vm.ntips,
                  classleve: _vm.classleve,
                  mClass: false,
                  nClass: true,
                  isShow: true,
                  hClass: false
                },
                on: { setModalInfo: _vm.setModalInfo }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content-row content-align-center content-row-center",
          staticStyle: { padding: "1.5rem 0" }
        },
        [
          _c(
            "div",
            {
              staticClass: "content-row content-row-column",
              staticStyle: {
                width: "90%",
                border: "1px solid #d7d5d6",
                "border-radius": ".5rem",
                overflow: "hidden"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "content-row",
                  staticStyle: { "border-bottom": "1px solid #d7d5d6" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "content-row content-row-center content-align-center",
                      staticStyle: { width: "16%", background: "#efeeec" }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "level-box level-mild font-12" },
                        [_vm._v(_vm._s(_vm.$t("potentialRisk")))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content-row content-align-center",
                      staticStyle: {
                        flex: "1",
                        "min-height": "2.5rem",
                        padding: "0 .7rem",
                        "border-left": "1px solid #d7d5d6"
                      }
                    },
                    [
                      _c("span", { staticClass: "font-18" }, [
                        _vm._v(_vm._s(_vm.$t("suggest")))
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content-row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "content-row content-row-center content-align-center",
                    staticStyle: { width: "16%", background: "#efeeec" }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "level-box level-severe font-12" },
                      [_vm._v(_vm._s(_vm.$t("heightRisk")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content-row content-align-center",
                    staticStyle: {
                      flex: "1",
                      "min-height": "2.5rem",
                      padding: "0 .7rem",
                      "border-left": "1px solid #d7d5d6"
                    }
                  },
                  [
                    _c("span", { staticClass: "font-18" }, [
                      _vm._v(_vm._s(_vm.$t("suggestSolve")))
                    ])
                  ]
                )
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cc4265a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cc4265a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_sympipad.vue
// module id = null
// module chunks = 